import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountingService } from '../../../services/accounting.service';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-accounting-categories',
    standalone: true,
    imports: [CommonModule, TableModule],
    template: `
    <div class="p-4">
      <h1 class="text-3xl font-bold mb-4">Chart of Accounts</h1>
      <p-table [value]="categories" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Type</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-cat>
          <tr>
            <td [style.padding-left.em]="cat.parent_id ? 2 : 0">{{ cat.name }}</td>
            <td>{{ cat.type | uppercase }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  `
})
export class CategoriesComponent implements OnInit {
    categories: any[] = [];
    constructor(private accountingService: AccountingService) { }
    ngOnInit() {
        this.accountingService.getCategories().subscribe(data => this.categories = data);
    }
}
